// This file is AUTOGENERATED, do not edit it manually!!!

export const customFields = {
    add_own_options: 'Add your own options',
    allActivities: 'Activity (task, issue, request)',
    AllActivities_group_title: 'Activity (task, issue, request) fields',
    batch_mark_as_optional: 'Mark as optional',
    batch_mark_as_required: 'Mark as required',
    boolean_field_type: 'Checkbox (yes/no)',
    create_cf: 'Create custom field',
    custom_field_could_not_be_deleted: 'Custom field \"{0}\" cannot be deleted',
    custom_field_could_not_be_removed: 'Custom field \"{0}\" cannot be removed',
    custom_field_readonly_warning: 'You can only view this custom field with your access level. To make changes, get in touch with the administrator.',
    customer: 'Customer',
    Customer_group_title: 'Customer fields',
    default_field_name: 'New field',
    delete_field_title: 'Delete custom field \"{0}\"?',
    everywhere: 'Everywhere',
    expense: 'Expense',
    Expense_group_title: 'Expense fields',
    field_is_used_in_formula: '1#This custom field is used in the {0} custom formula field#This custom field is used in {0} custom formula fields',
    field_non_editable_portfolio_restriction: 'This custom field does not belong to projects in <b>{0}</b> portfolio',
    field_non_editable_without_portfolio_restriction: 'This custom field does not belong to projects <b>{0} without portfolio</b>',
    field_non_editable_wrong_space: 'This custom field does not belong to <b>{0}</b> space',
    fields_plural: '1#{0} field#{0} fields',
    formula_description: 'For formula creation, you can use the Number, Money, and Hours field types, along with the +, -, *, and / operations. Parentheses can be added to create composite formulas.',
    formula_example: 'For example:',
    formula_field_type: 'Formula',
    formula_function_description: 'You can also use Working Days to calculate the difference between two dates in working days.',
    hyperlink_field_type: 'Hyperlink',
    issue: 'Issue',
    Issue_group_title: 'Issue fields',
    limitReachedMessage: 'Sorry, you have reached the maximum number of custom fields of the chosen type that you can add.',
    mark_as_optional_feedback: '1#{0} custom field has been successfully marked as optional#{0} custom fields have been successfully marked as optional',
    mark_as_optional_feedback_failure: '1#{0} custom field failed to be marked as optional because of its type (dropdown, formula, or checkbox)#{0} custom fields failed to be marked as optional because of their type (dropdown, formula, or checkbox)',
    mark_as_required_feedback: '1#{0} custom field has been successfully marked as required#{0} custom fields have been successfully marked as required',
    mark_as_required_feedback_failure: '1#{0} custom field failed to be marked as required because of its type (dropdown, formula, or checkbox)#{0} custom fields failed to be marked as required because of their type (dropdown, formula, or checkbox)',
    msg_deleteUsedValue: 'This value is used in {0} {1}',
    msg_entities_portfolioRemoved: 'This field will no longer be available for the entities included in the excluded portfolios.',
    msg_entities_spaceRemoved: 'This field will no longer be available for the entities included in the excluded spaces.',
    msg_lead_to: 'Do you want to save the changes?',
    msg_restrictionsAdded: 'This custom field will be portfolio-restricted.',
    msg_restrictionsRemoved: 'This custom field will no longer be portfolio-restricted.',
    msg_unportfolioedOff: 'This custom field will not be available for projects not included in portfolios.',
    msg_valueRemoved: 'Any items excluded from the list will be permanently deleted.',
    no_portfolio: 'Without portfolio',
    nowhere: 'Nowhere',
    numeric_field_type: 'Number',
    other_portfolios: 'Other portfolios',
    portfolio: 'Portfolio',
    Portfolio_group_title: 'Portfolio fields',
    project: 'Project',
    Project_group_title: 'Project fields',
    readonly_warning_no_access_to_portfolios: 'You can only view this custom field because it is associated with portfolios that you do not have access to.',
    remove_field_description: 'The custom field will still available in Company settings.',
    remove_field_title: 'Do you want to remove the \"{0}\" custom field from \"{1}\"?',
    request: 'Request',
    Request_group_title: 'Request fields',
    required_fileds_not_filled: '1#{0} required field is not filled in#{0} required fields are not filled in',
    select_from: 'Select custom field',
    spaces_field_label: 'Spaces',
    spaces_field_section_title: 'Available in spaces',
    task: 'Task',
    Task_group_title: 'Task fields',
    text_add: 'Add',
    text_add_new_item: 'Add a new item or use Ctrl+V to paste a list of items',
    text_add_portfolio: 'Add portfolio',
    text_addDescription: 'Add description',
    text_all_objects: 'All objects',
    text_available_in: 'Portfolios for the field',
    text_create_new_field: 'Add custom field',
    text_currentIdentity: 'Start from',
    text_custom_field_for: 'Field for',
    text_delete: 'Delete field',
    text_delete_permanently: 'Delete permanently',
    text_deleteValue: 'Delete value',
    text_edit: 'Edit field',
    text_empty_page_part1: 'Do you need more flexibility to track and report on your data?',
    text_empty_page_part2: 'Add your own fields for projects, tasks, users and more...',
    text_error_title: 'The operation could not be completed.',
    text_field_type: 'Text',
    text_fieldName: 'Field name',
    text_fieldType: 'Field type',
    text_filter: 'Custom fields for',
    text_include_in_unportfolioed_projects: 'Also show it for projects not included in portfolios',
    text_isIdentity: 'Auto-increment',
    text_isNumeric: 'Do not show decimals',
    text_isRequired: 'Required',
    text_place_plural: '1#place#places',
    text_remainingValuesTemplate: 'show \"{0}\" hidden items at the top of the list',
    text_remove: 'Delete',
    text_restricted_by_portfolio: 'Limit by portfolio',
    text_selectionMode: 'Selection mode',
    text_set_restrictions: 'Show this field only for projects included in selected portfolios',
    textarearich_field_type: 'Paragraph text (rich formatting)',
    timeEntry: 'Time entry',
    TimeEntry_group_title: 'Time entry fields',
    tooltip_disable_batch: 'You can only view the custom field with your access level. To make changes, get in touch with the administrator.',
    tooltip_everywhere: '<b>Everywhere</b> - the custom field has no visibility restrictions.',
    tooltip_nowhere: '<b>Nowhere</b> - the custom field is not included anywhere.',
    tooltip_other_portfolios: '<b>Other portfolios</b> - refers to portfolios you do not have the necessary permissions to access.',
    tooltip_portfolio_and_without_part1: '<b>Portfolio name, </b>',
    tooltip_portfolio_and_without_part2: '<b>Without portfolio</b> - the custom field is included in entities in selected portfolios and entities without portfolios.',
    tooltip_portfolio_name: '<b>Portfolio name</b> - the custom field is included in selected portfolios.',
    tooltip_without_portfolio: '<b>Without portfolio</b> - the custom field is included in entities without portfolios.',
    unknown_portfolio_description: 'Refers to portfolios you do not have the necessary permissions to access.',
    upgradeToEnterpriseMessage: 'You have reached the limit for Team Edition. Please <a href=\"{licenseUrl}\" target=\"_blank\">upgrade</a> to {brandName} Enterprise Edition.',
    use_cfs_options: 'Use custom field as a source of options',
    use_own_options: 'Use your own options',
    user: 'User',
    user_checkbox_list_text: 'User multi-select',
    user_dropdown_text: 'User dropdown',
    User_group_title: 'User fields',
    validation_error_InvalidBracketsNumber: 'Invalid parentheses usage',
    validation_error_InvalidField: 'Invalid field entry. The field \"{0}\" does not exist',
    validation_error_InvalidOperation: 'Invalid math operations usage. Only the operators ‘+’, ‘-’, ‘*’, and ‘/’ are allowed',
    validation_error_InvalidSymbol: 'Invalid symbols usage',
    validation_error_MismatchedArgumentType: 'Only dates can be used as arguments for the $WORKING_DAYS function.',
    validation_error_MismatchedInput: 'Incomplete formula. Ensure that all the symbols and operators are provided to create a valid formula',
    validation_error_MismatchedOperandType: 'Date fields cannot be used in arithmetic operations. Use the function $WORKING_DAYS(@Date1, @Date2) to work with them.',
    validation_error_MismatchedReturnType: 'Date fields cannot be used in arithmetic operations. Use the function $WORKING_DAYS(@Date1, @Date2) to work with them.',
    validation_error_Unknown: 'Invalid formula format. The formula you entered is in an invalid format and could not be parsed successfully',
    visibility_title: 'Visibility',
    warning_linked_global_field_activities: 'Changes to this custom field will affect activities in multiple spaces.',
    warning_linked_global_field_expenses: 'Changes to this custom field will affect expenses in multiple spaces.',
    warning_linked_global_field_projects: 'Changes to this custom field will affect projects in multiple spaces.',
    warning_linked_global_field_time: 'Changes to this custom field will affect time entries in multiple spaces.',
    warning_wont_visible_without_space: 'Custom field won\'t be visible to users until it\'s added to space.',
};
